import { Link } from "react-router-dom";

export default function SocialProof() {
  return (
    <section className="w-full bg-background-50 py-16 md:py-24 px-6 md:px-10">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-shrink-0 w-full lg:w-[380px]">
            <div className="relative">
              <div className="aspect-[3/4] w-full rounded-2xl overflow-hidden bg-background-200">
                <img
                  src="https://readdy.ai/api/search-image?query=Clean%20modern%20desk%20setup%20with%20dual%20monitors%20displaying%20colorful%20analytics%20dashboards%20and%20spreadsheet%20charts%20white%20ceramic%20coffee%20cup%20succulent%20plant%20minimalist%20notebook%20on%20warm%20oak%20desk%20natural%20window%20light%20professional%20workspace%20photography%20high%20detail%20bright%20airy%20atmosphere&width=600&height=800&seq=workspace-analytics-march-2026&orientation=portrait"
                  alt="Ecommerce sourcing workspace with spreadsheet analytics"
                  title="GTBuy Spreadsheet — Structured Sourcing Workspace"
                  className="w-full h-full object-cover"
                  loading="lazy"
                />
              </div>
              <div className="absolute -bottom-4 -right-4 w-24 h-24 rounded-full bg-accent-100 flex items-center justify-center">
                <i className="ri-double-quotes-l text-accent-600 text-3xl"></i>
              </div>
            </div>
          </div>

          <div className="flex-1">
            <span className="inline-block px-3 py-1 rounded-full bg-secondary-100 text-secondary-800 text-xs font-medium mb-4">
              Proven Workflow
            </span>
            <blockquote className="font-heading text-2xl md:text-3xl text-foreground-950 leading-relaxed mb-6">
              &ldquo;Switching to a structured spreadsheet system transformed how I manage
              supplier data. The GTBuy approach makes comparing hundreds of products across
              multiple vendors actually manageable.&rdquo;
            </blockquote>
            <p className="text-sm text-foreground-700 mb-1 font-medium">
              — Ecommerce Operator, 3+ Years Sourcing Experience
            </p>
            <p className="text-xs text-foreground-500 mb-6">
              Managing 500+ SKU catalog with spreadsheet-based sourcing
            </p>
            <Link
              to="/what-is-gtbuy-spreadsheet"
              className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-accent-100 text-accent-800 text-sm font-medium hover:bg-accent-200 transition-colors cursor-pointer whitespace-nowrap"
            >
              Read Success Story <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}